import { Layout } from "antd";
import Footer from "./Footer";

const { Content } = Layout;

export default function ContentWrapper({
  children,
  sidebarWidth = 0,
  hasBreadcrumb = false,
}) {
  const HEADER_HEIGHT = 64;
  const BREADCRUMB_HEIGHT = 50;
  const EXTRA_GAP = 30;

  const paddingTop =
    HEADER_HEIGHT + (hasBreadcrumb ? BREADCRUMB_HEIGHT : 0) + EXTRA_GAP;

  return (
    <Content
      className="app-content"
      style={{
        marginLeft: sidebarWidth,
        paddingTop,
        transition: "margin-left 0.4s ease",
        minHeight: "100vh",
      }}
    >
      <div className="bodyContentWrap">{children}</div>
      {/* FOOTER */}
      <Footer />
    </Content>
  );
}
